import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PricingPlans from './pages/pricing-plans';
import ContactSupport from './pages/contact-support';
import DemoPlayground from './pages/demo-playground';
import HeroLanding from './pages/hero-landing';
import PrivacyPolicy from './pages/privacy-policy';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HeroLanding />} />
        <Route path="/pricing-plans" element={<PricingPlans />} />
        <Route path="/contact-support" element={<ContactSupport />} />
        <Route path="/demo-playground" element={<DemoPlayground />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/hero-landing" element={<HeroLanding />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
